import React from "react";

const Input = ({
  label,
  type = "text",
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  hint,
  readOnly = false,
  disabled = false,
  autoComplete,
  rightElement,
  required,
}) => {
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium text-textPrimary mb-1.5"
        >
          {label}
          {required && <span className="text-statusRed ml-0.5">*</span>}
        </label>
      )}
      <div className="relative">
        <input
          id={name}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          readOnly={readOnly}
          disabled={disabled}
          autoComplete={autoComplete}
          className={`input-field ${error ? "input-field-error" : ""} ${
            rightElement ? "pr-10" : ""
          } ${readOnly ? "bg-pageBg cursor-default" : ""} ${
            disabled ? "opacity-50 cursor-not-allowed" : ""
          }`}
        />
        {rightElement && (
          <div className="absolute inset-y-0 right-3 flex items-center">
            {rightElement}
          </div>
        )}
      </div>
      {hint && !error && (
        <p className="mt-1 text-xs text-textMuted">{hint}</p>
      )}
      {error && (
        <p className="mt-1 text-xs text-statusRed">{error}</p>
      )}
    </div>
  );
};

export default Input;
